import { createContext, useContext } from "react";

/**
 * Opens Owner tools over the page, as the backtick key does, giving focus back
 * to `focusAfter` on closing; null where it can't be opened (a tech, or /tools,
 * where the tools are the page). For the user menu: on a phone, a backtick is
 * hard to type with no keyboard open (the owner, 2026-10-15).
 */
export type OpenOwnerTools = (focusAfter: HTMLElement | null) => void;

export const OwnerToolsOpener = createContext<OpenOwnerTools | null>(null);

export function useOwnerToolsOpener(): OpenOwnerTools | null {
  return useContext(OwnerToolsOpener);
}
